import React from "react";
import {AuthProvider, UserProvider} from "./AuthContext";
import {LoadingProvider} from "./LoadingContext";
import {SettingsProvider} from "./SettingsContext";
import {ServerConnectionErrorProvider} from "./ServerConnectionErrorContext";

const Provider = ({children}) => {

    return (
        <AuthProvider>
            {children}
        </AuthProvider>
    );
};

export {Provider};
